import React from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { useNavigate,useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import getWebsite from '../actions/Website';
import { parseBreadcrumbsList } from '../../store/Actions';
import { useDispatch } from 'react-redux';
import Dropdown from '../../components/Reusables/Dropdown';
import getResponseEntity from '../actions/Entity.js';
import Cookies from 'js-cookie'
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';
import { trim } from '../Reusables/Function';

function AddWebsite(props) {
    const {id} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [name, setName] = useState(null);
    const [url, setUrl] = useState(null);
    const [entityList, setEntityList] = useState([]);
    const [entityid, setEntityId] = useState(null);
    const [errormsg, setError] = useState(null);
    const [entityLabel, setEntityLabel] = useState('Select Portal');
    const [page, setPage] = useState("");
    const [details, setDetails] = useState(null);
    const [isChecked, setChecked] = useState(false);
    const [enable, setEnable] = useState(true);
    const [open, setOpen] = useState(null)
    const [templateId, setTemplateId] = useState(null);
    const [templateLabel, setTemplateLabel] = useState('Select Template');
    const [templateList, setTemplateList] = useState([]);

    const handlename = (value) => {
        setName(value);
    }

    const handleUrl = (value) => {
        setUrl(value);
    }

    const CreateWebsite = () => {
        setEnable(false);
        const details = {
            siteName: trim(name),
            siteUrl: trim(url),
            brandId: entityid,
            templateId: templateId
        }
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getWebsite.AddWebsite(details, '/api/websites/add', accesstoken, (data) => {
                    setEnable(true);
                    if(data.status == 200) {
                        navigate('/websites/list')
                        setOpen(false)
                    } else if(data.status == 400 || data.status == 404) {
                        setError(data.data.message);
                        setOpen(true)                    
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })
        
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    const EditWebsite = () => {
        setEnable(false);
        const details = {
            IdWebsites: parseInt(id),
            SiteName: trim(name),
            SiteUrl: trim(url),
            BrandId: entityid,
            DnsAdded: isChecked
        }
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getWebsite.EditWebsite(details, '/api/websites/edit', accesstoken, (data) => {
                    setEnable(true);
                    if(data.status == 200) {
                        navigate('/websites/list')
                        setOpen(false)
                    } else if(data.status == 400 || data.status == 404) {
                        setError(data.data.message);
                        window.scroll(0,0)
                        setOpen(true);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                })  
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    useEffect(() => {
        setOpen(false)
        window.scroll(0, 0);
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.GetBrandList(`/api/brand/dropdown?parent=${true}`, accesstoken, (response) => {
                    if(response.status == 200) {
                        const entityArray = [];
                        response.data.data.map((task) => {
                            const entityObject = {id: 0, name: ''}
                            entityObject.id = task["idBrand"];
                            entityObject.name = task["name"];
                            entityArray.push(entityObject);
                        })
                        setEntityList(entityArray);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                })

                getWebsite.GetTemplateList('/api/websites/templates', accesstoken, (response) => {
                    if(response.status == 200) {
                        const templateArray = [];
                        response.data.data.map((item) => {
                            const templateObject = {id: 0, name: ''}
                            templateObject.id = item["idTemplates"];
                            templateObject.name = item["templateName"];
                            templateArray.push(templateObject);
                        })
                        setTemplateList(templateArray);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                })

                if(window.location.href.includes('new')) {
                    const breadcrumbsListNew = [
                        { "name": "Home", "url": "" },
                        { "name": "Websites", "url": "websites/list" },
                        { "name": "Websites - New", "url": "websites/new" }
                    ];
                    setPage("new");
                    dispatch(parseBreadcrumbsList(breadcrumbsListNew));
                } else if(window.location.href.includes('edit')) {
                    setPage("edit");
                    getWebsiteDetails("edit", accesstoken);
                }
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [])

    const getWebsiteDetails = (page, accesstoken) => {
        getWebsite.GetWebsiteDetails(`/api/websites/websitedetails/${id}`, accesstoken, (data) => {
            if(data.status == 200) {
                getParsedValues(data.data.data);
                setDetails(data.data.data);
                if(page == "edit") {
                    const breadcrumbsListEdit = [
                        { "name": "Home", "url": "" },
                        { "name": "Websites", "url": "websites/list" },
                        { "name": data.data.data.siteName != null && `${data.data.data.siteName}: Edit`, "url": `websites/${id}/edit` }
                    ];
                    dispatch(parseBreadcrumbsList(breadcrumbsListEdit));
                }
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const getParsedValues = (data) => {
        const response = data;
        setName(response.siteName);
        setUrl(response.siteUrl);
        setChecked(response.dnsAdded);
    }

    useEffect(() => {
        (entityList.length > 0 && details != null) && entityList.map((item) => {
            if(details.brandId == item.id) {
                setEntityLabel(item.name);
                setEntityId(item.id);
            }
        })
    }, [entityList, details])

    const handleCheckbox = () => {
        console.log("[Websites] checkbox");
        setChecked(!isChecked);
    }

    return (
        <div className="Add-new-website-container">
            <Header />
            <div className='row websites-section'>
                <Sidebar />
                <div className="col-10 website-page-section">
                    <div className="search-section-websites">
                        <Breadcrumbs />
                    </div>
                    <div className="add-new-website">
                        <div className="label-input-row">
                            <div className='label-input-col'>
                                <div className='label-input label-input-name'>
                                    <label className="required">Name</label>
                                    <div className='input-box'> 
                                        <input type="text" value={name} onChange={(e) => handlename(e.target.value)} maxLength={45}></input>
                                    </div>                                            
                                </div>
                            </div>
                            <div className='label-input-col'>
                                <div className='label-input label-input-name'>
                                    <label className="required">Portal</label>
                                    <div className={`dropdown-brand ${page == 'new' ? 'pointer-all' : 'pointer-none'}`}> 
                                        <Dropdown selectedItem={(name, id) => setEntityId(id)}  label={entityLabel}  handleLabel={(value) => setEntityLabel(value)} list={entityList} enable={page == 'new' ? true : false}/>
                                    </div>                                            
                                </div>
                            </div>
                        </div>
                        <div className="label-input-row input-web">
                            <div className='label-input-col'>
                                <div className='label-input label-input-name'>
                                    <label className="required">Url</label>
                                    <div className='input-box'> 
                                        <input type="text" value={url} onChange={(e) => handleUrl(e.target.value)} maxLength={45}></input>
                                    </div>                                            
                                </div>
                            </div>
                            {page == "new" &&
                            <div className='label-input-col'>
                                <div className='label-input label-input-name'>
                                    <label className="required">Template</label>
                                    <div className='dropdown-brand'> 
                                        <Dropdown selectedItem={(name, id) => setTemplateId(id)}  label={templateLabel}  handleLabel={(value) => setTemplateLabel(value)} list={templateList} enable={true}/>
                                    </div>                                            
                                </div>
                            </div>}
                        </div>
                    </div>
                    <hr />
                    <div className="button-text">
                        {page == "new" ? <button disabled={enable ? false : true} className={enable ? 'create-website-button enable' : 'create-website-button disable'} onClick={CreateWebsite}>Create</button> : 
                        <button disabled={enable ? false : true} className={enable ? 'edit-website-button enable' : 'edit-website-button disable'} onClick={EditWebsite}>Save</button>}
                    </div>
                </div>
            </div>
            <div>
                <Footer />  
            </div>
            <Snackbars error={errormsg} open={open} setOpen={setOpen}/>
        </div>
    )
}

export default AddWebsite;
